const SupportTicketsRoutes = {
  getTickets: "/support/tickets",
  getTicketDetails: "/support/details",
  sendTicket: "/support/sendMessage",
  updateTicketStatus: "/support/change",
  createTicket: "/support/create",
  getTicketType: "/support/types",
}
export default SupportTicketsRoutes